import { gql } from "@apollo/client";
import { BRANCH_INFO } from "../fragments";

export const GET_BRANCH_LIST = gql`
  query branchList {
    branchList {
      ...branchInfo
    }
  }
  ${BRANCH_INFO}
`;
